import React from 'react';
import PropTypes from 'prop-types';
import DocumentTitle from 'react-document-title';
import { connect } from 'react-redux';
import { isEmpty, isEqual, get, toLower } from 'lodash';
import { resetErrorMessage } from '../actions/internal';
import {
  loadAccountPlayers,
  loadAccountPlayersFilters,
  loadAccountPlayersCSVReport,
  loadUserActionsCSVReport,
} from '../actions/partner';
import TopNavBar from './nav/TopNavBar';
import SubNavBar from './nav/SubNavBar';
import AccountPlayersContainer from './accountplayers/AccountPlayersContainer';
import AccountPlayersFilterContainer from './accountplayers/AccountPlayersFilterContainer';

class AccountPlayersPage extends React.Component {
  componentDidMount() {
    this.props.resetErrorMessage();
    this.props.loadAccountPlayersFilters({source: 'init'});
    this.props.loadAccountPlayers(this.props.history.location.search, {source: 'init'});
    this.props.loadAccountPlayersCSVReport(0);
    this.props.loadUserActionsCSVReport(0);
  }

  componentDidUpdate(prevProps) {
    const isFromNavBar = get(this.props.location, 'state.from') === 'navbar' && get(prevProps.location, 'state.from') !== 'navbar';
    if (isFromNavBar || (!isEqual(prevProps.location, this.props.location) && toLower(this.props.history.action) === 'pop')) {
      this.props.loadAccountPlayers(this.props.history.location.search, {source: 'init'});
    }
  }

  render() {
    if (!this.props.isAuthChecked) return null;
    return (
      <DocumentTitle title='Sparkler - Children'>
        <div>
          <TopNavBar />
          <SubNavBar />
          <div className="row">
            <div className="column">
              <AccountPlayersFilterContainer />
              <AccountPlayersContainer />
            </div>
          </div>
        </div>
      </DocumentTitle>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isAuthChecked: state.auth.isAuthChecked,
    isData: !isEmpty(state.dashboard),
  };
};

AccountPlayersPage.propTypes = {
  history: PropTypes.object,
  location: PropTypes.object,
  isAuthChecked: PropTypes.bool.isRequired,
  loadAccountPlayers: PropTypes.func.isRequired,
  loadAccountPlayersFilters: PropTypes.func.isRequired,
  loadAccountPlayersCSVReport: PropTypes.func.isRequired,
  loadUserActionsCSVReport: PropTypes.func.isRequired,
  resetErrorMessage: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, {
  resetErrorMessage,
  loadAccountPlayers,
  loadAccountPlayersFilters,
  loadAccountPlayersCSVReport,
  loadUserActionsCSVReport,
})(AccountPlayersPage);
